import { render, staticRenderFns } from "./ContactCompanies.vue?vue&type=template&id=1c88798c&scoped=true"
import script from "./ContactCompanies.vue?vue&type=script&lang=js"
export * from "./ContactCompanies.vue?vue&type=script&lang=js"
import style0 from "./ContactCompanies.vue?vue&type=style&index=0&id=1c88798c&prod&scoped=true&lang=css"
import style1 from "./ContactCompanies.vue?vue&type=style&index=1&id=1c88798c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c88798c",
  null
  
)

export default component.exports